import { Box, Flex, Text, UnstyledButton } from '@mantine/core';
import { SiestaBackground } from 'src/UI/common/SiestaBackground';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import AreasEditedSummary from './AreasEditedSummary';

type TrackedSuggestion = {
  key: string;
  textContent: string;
  scrollIntoView: () => void;
};

type SiestaActionBarProps = {
  suggestions: TrackedSuggestion[];
  onApply: () => void;
  onDiscard: () => void;
};

export default function SiestaActionBar({ suggestions, onApply, onDiscard }: SiestaActionBarProps) {
  return (
    <Box
      pos="relative"
      px="xxl"
      py="sm"
      style={{
        borderRadius: 24,
        overflow: 'hidden',
      }}
    >
      <SiestaBackground />

      <Flex
        align="center"
        justify={suggestions.length > 0 ? 'space-between' : 'flex-end'}
        pos="relative"
        style={{ zIndex: 2 }}
      >
        {suggestions.length > 0 && (
          <AreasEditedSummary editCount={suggestions.length} suggestions={suggestions} />
        )}

        <Flex align="center" gap="md">
          <UnstyledButton
            onClick={onApply}
            px="sm"
            py="xxs"
            style={{
              backgroundColor: 'white',
              borderRadius: 24,
            }}
          >
            <Text size="sm" fw={FONT_WEIGHTS.medium} c="brand.8">
              Apply changes
            </Text>
          </UnstyledButton>

          <UnstyledButton onClick={onDiscard}>
            <Text size="textMd" fw={FONT_WEIGHTS.semibold} c="white">
              Discard
            </Text>
          </UnstyledButton>
        </Flex>
      </Flex>
    </Box>
  );
}
